import PropTypes from 'prop-types';

export function TooltipWrap(props) {
  if (props.tooltipOpen) {
    return props.children;
  } else {
    return null;
  }
}

TooltipWrap.propTypes = {
  /**
   * component to be displayed when tooltip is displayed
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  /**
   * Boolean to manage if tooltip should be displayed
   */
  tooltipOpen: PropTypes.bool.isRequired,
};
